module.exports = __webpack_public_path__ + "img/auto.4d4da9de.jpg";